import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import axios from "axios";
import SearchBar from "components/SearchBar/SearchBar";
import SearchBarProduct from "components/SearchBar/SearchBarProduct";
import { useSelector } from "react-redux";

// components

export default function CardProductTable() {
  const [datas, setDatas] = useState("");
  const [pending, setPending] = useState(true);
  const [result, setResult] = useState("");
  const [category, setCategory] = useState("");
  const [units, setUnits] = useState("");
  const [productGroup, setProductGroup] = useState("");
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [datasSearch, setDatasSearch] = useState("");
  const [currentRow, setCurrentRow] = useState(null);
  const { user } = useSelector(state => state.user)

  useEffect(() => {
    // axios.get(`http://${process.env.REACT_APP_API_URL}/products/search-All`, {
    //   headers: {
    //     Bearer: localStorage.getItem('token')
    //   }
    // }).then((response) => {
    //   // console.log(response);
    //   if (response.status === 200) {
    //     setDatas(response.data);
    //     setResult(response.data);
    //     setPending(false);
    //   }
    // }
    // ).catch((error) => {
    //   if (error.response.data.status === 401) {
    //     window.location.href = "/auth/login";
    //   }
    //   console.log(error);
    //   // console.log(error.response.data.message);
    // });

    axios.get(`http://${process.env.REACT_APP_API_URL}/utility/search-category`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setCategory(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });

    axios.get(`http://${process.env.REACT_APP_API_URL}/utility/search-unit`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setUnits(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });

    axios.get(`http://${process.env.REACT_APP_API_URL}/utility/search-product-group`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setProductGroup(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });

  }, [])

  const columns = [
    {
      name: 'รูปภาพสินค้า',
      selector: row => row?.product.image && <img src={`data:image/jpeg;base64,${row.product.image}`} alt={row.product.productName} width="100" height="100" />,
      maxwidth: '300px',
      maxheight: '30px',

    },
    {
      name: 'ชื่อ',
      selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.product.productName}</div>,
      maxwidth: '300px',
    },
    {
      name: 'กลุ่มสินค้า',
      selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}> {productGroup && productGroup?.find(x => x.id === row.product.productGroup)?.productGroupName}</div>,
      maxwidth: '300px'

    },
    {
      name: 'ประเภท',
      selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{category && category?.find(x => x.id === row.product.category)?.categoryName}</div>,
      maxwidth: '150px'

    },
    {
      name: 'ยี่ห้อ',
      selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.product.model}</div>,
      maxwidth: '100px'

    },
    {
      name: 'จำนวน',
      selector: row => row.product.qty,
      maxwidth: '100px'

    },
    {
      name: 'หน่วย',
      selector: row => units && units?.find(x => x.id === row.product.unit)?.unitName,
      maxwidth: '100px'

    },
    {
      name: 'ราคาทุน',
      selector: row => user.role === 99 && row.product.cost,
      maxwidth: '50px'

    },
    {
      name: 'ราคาหน่วย',
      selector: row => row.product.pricePerUnit,
      maxwidth: '50px'

    },
    {
      name: 'Edit',
      button: true,
      cell: (row) => user.role === 99 && <button onClick={() => window.location.href = "/product/update/" + row?.product?.productCode}><i className="mr-2 text-sm fas fa-pen" /></button>,
    },
    {
      name: 'Delete',
      button: true,
      cell: (row) =>  user.role === 99 &&<button onClick={() => handleDelete(row)}><i className="mr-2 text-sm fas fa-trash" /></button>,
    },
  ];
  const columns2 = [
    {
      name: 'รูปภาพสินค้า',
      selector: row => row.image && <img src={`data:image/jpeg;base64,${row.image}`} alt={row.productName} width="100" height="100" />,
      maxwidth: '300px',

    },
    {
      name: 'ชื่อ',
      selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.productName}</div>,
      maxwidth: '300px',
    },
    {
      name: 'กลุ่มสินค้า',
      selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}> {productGroup && productGroup?.find(x => x.id === row.productGroup)?.productGroupName}</div>,
      maxwidth: '300px'

    },
    {
      name: 'ประเภท',
      selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{category && category?.find(x => x.id === row.category)?.categoryName}</div>,
      maxwidth: '150px'

    },
    {
      name: 'ยี่ห้อ',
      selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.model}</div>,
      maxwidth: '100px'

    },
    {
      name: 'จำนวน',
      selector: row => row.qty,
      maxwidth: '100px'

    },
    {
      name: 'หน่วย',
      selector: row => units && units?.find(x => x.id === row.unit)?.unitName,
      maxwidth: '100px'

    },
    {
      name: 'ราคาทุน',
      selector: row => user.role === 99 && row.cost,
      maxwidth: '50px'

    },
    {
      name: 'ราคาหน่วย',
      selector: row => row.pricePerUnit,
      maxwidth: '50px'

    },
    {
      name: 'Edit',
      button: true,
      cell: (row) => user.role === 99 && <button onClick={() => window.location.href = "/product/update/" + row?.productCode}><i className="mr-2 text-sm fas fa-pen" /></button>,
    },
    {
      name: 'Delete',
      button: true,
      cell: (row) => user.role === 99 &&  <button onClick={() => handleDelete(row)}><i className="mr-2 text-sm fas fa-trash" /></button>,
    },
  ];

  const handleDelete = (row) => {
    console.log(row);
    const productCode = { isDelete: 1, productCode: row.product?.productCode ?? row.productCode }
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(`http://${process.env.REACT_APP_API_URL}/products/save`, productCode, {
          headers: {
            Bearer: localStorage.getItem('token')
          }
        }).then((response) => {
          // console.log(response);
          if (response.status === 200) {
            Swal.fire({
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success"
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
            //  window.location.href = "/product";
          }
        }
        ).catch((error) => {
          if (error.response.data.status === 401) {
            window.location.href = "/auth/login";
          }
          //  console.log(error);
          console.log(error.response.data.message);
        });
      }
    });
  }

  const customStyles = {
    table: {
      style: {
        borderRadius: "20px",
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        // override the row height
        '&:hover': {
          // cursor: 'pointer',
          backgroundColor: "#B4BDFF",

        },
      },
    },
    expanderCell: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        backgroundColor: "#83A2FF",

      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        backgroundColor: "#83A2FF",

      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',

      },

    },

  };

  const fetchOrders = async pageNum => {
    setPending(true);

    axios.post(`http://${process.env.REACT_APP_API_URL}/products/search-all-pagination`, { page: pageNum, pageSize: perPage }, {
      headers: {
        bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        setDatas(response.data.productHis);
        setResult(response.data.productHis);
        setTotalRows(response.data.count);
        setPending(false);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error.response.data.message);
    });

    // axios.get(`http://${process.env.REACT_APP_API_URL}/products/count`, {
    //   headers: {
    //     Bearer: localStorage.getItem('token')
    //   }
    // }).then((response) => {
    //   if (response.status === 200) {
    //     setTotalRows(response.data.totals);
    //   }
    // }
    // ).catch((error) => {
    //   if (error.response.data.status === 401) {
    //     window.location.href = "/auth/login";
    //   }
    //   console.log(error);
    // });
  };

  const handlePageChange = page => {
    fetchOrders(page);
  };
  // console.log(result);
  const handlePerRowsChange = async (newPerPage, pageNum) => {
    setPending(true);
    // console.log(newPerPage,pageNum);
    axios.post(`http://${process.env.REACT_APP_API_URL}/products/search-all-pagination`, { page: pageNum, pageSize: newPerPage }, {
      headers: {
        bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setDatas(response.data.productHis);
        setResult(response.data.productHis);
        setPerPage(newPerPage);
        setPending(false);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error.response.data.message);
    });
  };

  useEffect(() => {
    fetchOrders(1); // fetch page 1 of users

  }, []);

  const ExpandedComponent = ({ data }) => {
    return (
      <>
       {data && <div className="flex justify-center bg-gray" style={{ background: "gray" }} >

          <div className="grid p-5 " style={{ backgroundColor: "#83A2FF", borderRadius: "20px", margin: "15px" }}  >
            <p>รหัสสินค้า : {data.product.productCode}</p>
            <p>ชื่อสินค้า : {data.product.productName}</p>
            <p>กลุ่มสินค้า : {data.product.productGroup}</p>
            <p>ประเภทสินค้า{data.product.category}</p>
            <p>ยี่ห้อ : {data.product.model}</p>
            <p>หน่วย : {data.product.unit}</p>
            {user.role === 99 &&<p>ราคาทุน : {data.product.cost}</p>}
            <p>ราคาต่อหน่วย : {data.product.pricePerUnit}</p>

          </div>
          <div className="grid p-5">

            {/* 
            <p>สร้างโดย : {data.product.createBy}</p>
            <p>{new Date(data.product.createDate).toLocaleDateString("th")}</p>
            <p>แก้ไขโดย : {data.product.updateBy}</p>
            <p>{new Date(data.product.updateDate).toLocaleDateString("th")}</p> */}
          </div>
          <div className="grid p-5" style={{ backgroundColor: "#83A2FF", borderRadius: "20px", margin: "15px" }}>
            <img src={`data:image/jpeg;base64,${data.product.image}`} alt={data.product.productName} width="400" height="400" />
          </div>
        </div>}
      </>
    );
  };
  const ExpandedComponent2 = ({ data }) => {
    return (
      <>
       {data && <div className="flex justify-center bg-gray" style={{ background: "gray" }} >

          <div className="grid p-5 " style={{ backgroundColor: "#83A2FF", borderRadius: "20px", margin: "15px" }}  >
            <p>รหัสสินค้า : {data.productCode}</p>
            <p>ชื่อสินค้า : {data.productName}</p>
            <p>กลุ่มสินค้า : {data.productGroup}</p>
            <p>ประเภทสินค้า{data.category}</p>
            <p>ยี่ห้อ : {data.model}</p>
            <p>หน่วย : {data.unit}</p>
            <p>ราคาทุน : {data.cost}</p>
            <p>ราคาต่อหน่วย : {data.pricePerUnit}</p>

          </div>
          <div className="grid p-5">

            {/* 
            <p>สร้างโดย : {data.product.createBy}</p>
            <p>{new Date(data.product.createDate).toLocaleDateString("th")}</p>
            <p>แก้ไขโดย : {data.product.updateBy}</p>
            <p>{new Date(data.product.updateDate).toLocaleDateString("th")}</p> */}
          </div>
          <div className="grid p-5" style={{ backgroundColor: "#83A2FF", borderRadius: "20px", margin: "15px" }}>
            <img src={`data:image/jpeg;base64,${data.image}`} alt={data.productName} width="400" height="400" />
          </div>
        </div>}
      </>
    );
  };


  return (
    <>
      <div className="p-5 " >
        {/* <SearchBar data={datas} setResult={setResult} /> */}
        <SearchBarProduct data={datas} setResult={setResult} setPending={setPending} setTotalRows={setTotalRows} setPerPage={setPerPage} setDatasSearch={setDatasSearch} />
      </div>
      <div className="block w-full mb-1 overflow-x-auto rounded-lg ">
        {!datasSearch ? <DataTable
          data={result}
          columns={columns}
          customStyles={customStyles}
          pagination
          progressPending={pending}
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          paginationServer
          paginationTotalRows={totalRows}
          paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          onRowExpandToggled={(bool, row) => setCurrentRow(row)}
          expandableRowExpanded={(row) => (row === currentRow)}
          expandOnRowClicked
          onRowClicked={(row) => setCurrentRow(row)}
        >
        </DataTable>
          :
          <DataTable
            data={datasSearch}
            columns={columns2}
            pagination
            customStyles={customStyles}
            progressPending={pending}
            expandableRows
            expandableRowsComponent={ExpandedComponent2}
            paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
            onRowExpandToggled={(bool, row) => setCurrentRow(row)}
            expandableRowExpanded={(row) => (row === currentRow)}
            expandOnRowClicked
            onRowClicked={(row) => setCurrentRow(row)}
          >
          </DataTable>}
      </div>
    </>
  );
}
